import React, {useState, useEffect} from "react";
import DataTable from "react-data-table-component";
import { Modal } from "react-bootstrap";
import PageHeader from "../../components/common/PageHeader";
import UserServices from "../../services/UserServices";
import useUserSubmit from "../../hooks/useUserSubmit";
import Error from "../../components/Input/Error";
import DropDownService from "../../services/DropDownService";
import useAsync from "../../hooks/useAsync";
import ModalLoading from "../../components/Loading/ModalLoading";
import { useLocation } from 'react-router-dom';

function UsersView() {   
    const [rowData, setrowData] = useState([]);
    const [columnT, setcolumnT] = useState([]);
    const [siEditModal, setSiEditModal] = useState("");
    const [userId, setUserId] = useState("");
    const [departmentDropdownData, setDepartmentDropdownData] = useState([]);
    
    const { data, loading } = useAsync(() => UserServices?.getAllUsers());
    const { data:moduledata } = useAsync(() => UserServices?.getAllModules());
    
    const location = useLocation();
    const { pathname } = location; 
    const { data:permissionData } = useAsync(() => DropDownService.getModulePermissions({ path:pathname, userId:localStorage.id})); 
    var addPermission = typeof permissionData?.data?.add === 'undefined' ? 1: permissionData?.data?.add; 
    var viewPermission = typeof permissionData?.data?.view === 'undefined' ? 1: permissionData?.data?.view;
    var editPermission = typeof permissionData?.data?.edit === 'undefined' ? 1: permissionData?.data?.edit; 
    var deletePermission = typeof permissionData?.data?.delete === 'undefined' ? 1: permissionData?.data?.delete; 
    var listPermission = typeof permissionData?.data?.list === 'undefined' ? 1: permissionData?.data?.list;

    const formInputStyle = {
        border: "2px solid #80808059"
    }
    
    const {  
        register,
        errors,
        onSubmit,
        handleSubmit,   
        deleteUser, 
        isModal,  
        setIsModal,  
        ShowEditValues, 
        isViewModal, setIsViewModal,
        status, setStatus, viewData,     
        isDeleteModal,
        setIsDeleteModal,
        privilegesave, setprivilegesave, setDataUpdate, dataUpdate
      } = useUserSubmit(siEditModal?._id);  
 
    useEffect(()=>{ 
        const getAllusers = async (data) => {
            const result = data;
            // const result = await UserServices.getAllUsers();
            //  console.log("result == ",result);
            setrowData(result?.users);
            
            var rowData = result?.users;
            console.log("rowdtaa", rowData); 
            var columnTs = "";
            columnTs = [ 
                {
                    name: "NAME",
                    selector: (rowData) => rowData?.name,
                    sortable: true,
                    cell: rowData => rowData?.name,
                    minWidth: "250px"
                }, 
                {
                    name: "USER NAME", 
                    selector: (rowData) => rowData?.username,
                    sortable: true,
                    cell: (rowData) => rowData?.username,
                }, 
                {
                    name: "EMAIL",
                    selector: (rowData) => rowData?.email,
                    sortable: true
                },
                { 
                    name: "STATUS",
                    selector: (rowData) => rowData?.status,
                    sortable: true,
                    cell: row => <span className={`badge ${row.status === "Completed" || row.status === "Active" ? 'bg-success' : "bg-warning"}`}>{row.status}</span>
                }, 
                {
                    name: "ACTION",
                    selector: (row) => { },
                    sortable: true,
                    cell: (row) => (<div className="btn-group" role="group" aria-label="Basic outlined example">
                        {viewPermission === 1 && (<button type="button" className="btn btn-outline-secondary" onClick={() => { setIsViewModal(true); ShowEditValues(row, "View"); setUserId(row?._id) }} ><i className="icofont-eye-alt text-primary"></i></button>)}
                        {editPermission === 1 && (<button type="button" className="btn btn-outline-secondary" onClick={() => { setIsModal(true); setSiEditModal(row); ShowEditValues(row, "Edit"); setUserId(row?._id) }}><i className="icofont-edit text-success"></i></button>)}
                        {deletePermission === 1 && (<button type="button" className="btn btn-outline-secondary deleterow" onClick={()=> {setIsDeleteModal(true); setUserId(row?._id)}}><i className="icofont-ui-delete text-danger"></i></button>)}
                    </div>) 
                } 
       
            ]
            setcolumnT(columnTs);   
        } 
    
        const getDepartmentDropdownData = async () => {
            const result = await DropDownService.getDepartmentDropDown();
            setDepartmentDropdownData(result); 
            // console.log(" getDepartmentDropdown == ",result);
        } 

        setTimeout(() => {  
            getAllusers(data);  
        }, 100); 
        getDepartmentDropdownData();

        
    }, [data]); 

    useEffect(()=>{     
        setTimeout(() => { 
            getModuleData();            
        }, 100);  
        
    }, [moduledata?.module, dataUpdate]); 
    
    const getModuleData = async () => {
        const modulesData = await UserServices?.getAllModules();
        setprivilegesave(modulesData?.module); 
        console.log(" modulesData?.module ==", modulesData?.module);
    }
 
    const handleClick = (e) => {
        var nameval = e.target.name;
        var ex = nameval.split("_");  
        var name = ex[0];
        var page = ex[1]; 
        // var checkparentID = ex[2];   
        var boxchecked = e.target.checked ? 1 : 0;
     
        // const privdata = {};  
        if(page === "list") {  
            const privdata = privilegesave.map((priv) => priv.name.en === name ? {...priv, permissions: {...priv.permissions, list:boxchecked}} : priv);
            setprivilegesave(privdata);     
            } else if(page === "add") { 
            const privdata = privilegesave.map((priv) => priv.name.en === name ? {...priv, permissions: {...priv.permissions, add:boxchecked}} : priv);
            setprivilegesave(privdata);    
            } else if(page === "edit") {
            const privdata = privilegesave.map((priv) => priv.name.en === name ? {...priv, permissions: {...priv.permissions, edit:boxchecked}} : priv);
            setprivilegesave(privdata);    
            } else if(page === "view") {
            const privdata = privilegesave.map((priv) => priv.name.en === name ? {...priv, permissions: {...priv.permissions, view:boxchecked}} : priv);
            setprivilegesave(privdata);    
            } else if(page === "delete") {
            const privdata = privilegesave.map((priv) => priv.name.en === name ? {...priv, permissions: {...priv.permissions, delete:boxchecked}} : priv);
            setprivilegesave(privdata);       
        }  
    };

    const handleAllClick = (e) => {
        var nameval = e.target.name; 
        var ex = nameval.split("_");  
        var name = ex[0];
        var Pid = ex[1];  
        var parentId = e.target.id; 
        var boxchecked = e.target.checked ? 1 : 0;
        if(Pid === "0") { 
        const privdata = privilegesave.map((priv) => priv.name.en === name ? {...priv, permissions: {...priv.permissions, list:boxchecked, edit:boxchecked, add:boxchecked, view:boxchecked, delete:boxchecked}} : priv);
        const privsddata = privdata.map((priv) => priv.parentId === parentId ? {...priv, permissions: {...priv.permissions, list:boxchecked, edit:boxchecked, add:boxchecked, view:boxchecked, delete:boxchecked}} : priv);
        console.log(" privsddata == ", privsddata);
        setprivilegesave(privsddata); 
        }else {  
        const privssdata = privilegesave.map((priv) => priv.name.en === name ? {...priv, permissions: {...priv.permissions, list:boxchecked, edit:boxchecked, add:boxchecked, view:boxchecked, delete:boxchecked}} : priv);
        const privdata = privssdata.map((priv) => priv.parentId === parentId ? {...priv, permissions: {...priv.permissions, list:boxchecked, edit:boxchecked, add:boxchecked, view:boxchecked, delete:boxchecked}} : priv);
        setprivilegesave(privdata);
        } 
    } 

    return (
        <div className="container-xxl">
            <PageHeader headerTitle="Users" addPermission={addPermission} renderRight={() => {
                return <div className="col-auto d-flex w-sm-100">
                    <button className="btn btn-dark btn-set-task w-sm-100" onClick={() => { setIsModal(true); setUserId(""); setDataUpdate(!dataUpdate); }}><i className="icofont-plus-circle me-2 fs-6"></i>Add User</button>
                </div>
            }} />
            <div className="row clearfix g-3">
                <div className="col-md-12">
                    {
                        listPermission === 1 && (
                            <div className="card"> 
                                <div className="card-body">
                                    <DataTable 
                                        title="Users" 
                                        columns={columnT}
                                        data={rowData}
                                        defaultSortField="title"
                                        pagination
                                        selectableRows={false}
                                        className="table myDataTable table-hover align-middle mb-0 d-row nowrap dataTable no-footer dtr-inline"
                                        highlightOnHover={true}
                                        progressPending={loading}
                                        progressComponent={<ModalLoading loading={loading} />}

                                    />
                                </div>
                            </div>
                        )
                    }
                    
                </div>
            </div>
            <Modal centered show={isModal} size="lg" onHide={() => { setIsModal(false); setSiEditModal("") }}>
                <form onSubmit={handleSubmit(onSubmit)}> 
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">{userId !== "" ? "Edit" : "Add"} User</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="deadline-form">
                    
                            <div className="row g-3 mb-3"> 
                                <div className="col-lg-6"> 
                                    <label htmlFor="name" className="form-label">Name</label>
                                    <input type="text" name="name" className="form-control" id="name" {...register(`name`, { required: `Name is required!`,
                  })} />
                                    <Error errorName={errors?.name} /> 
                                </div>
                                <div className="col-lg-6">
                                    <label htmlFor="username" className="form-label">User Name</label>
                                    <input type="text" name="username" className="form-control" id="username" {...register(`username`, { required: `User Name is required!`,
                  })}/>
                                <Error errorName={errors?.username} />
                                </div>
                            </div>
                            <div className="row g-3 mb-3"> 
                                <div className="col-lg-6"> 
                                    <label htmlFor="email" className="form-label">Email</label>
                                    <input type="text" className="form-control" name="email" id="email" {...register(`email`, { required: `Email is required!`,
                  })}/>
                                <Error errorName={errors?.email} />
                                </div>
                                <div className="col-lg-6">
                                    <label htmlFor="password" className="form-label">Password</label>
                                    <input type="password" className="form-control" name="password" id="password" {...register(`password`, { required: `Password is required!`,
                  })}/>
                                <Error errorName={errors?.password} />
                                </div>
                            </div>
                            <div className="row g-3 mb-3"> 
                                <div className="col-lg-6"> 
                                    <label htmlFor="phone" className="form-label">Mobile No.</label>
                                    <input type="text" className="form-control" name="phone" id="phone" {...register(`phone`, { required: `Mobile No. is required!`,
                  })}/> 
                                <Error errorName={errors?.phone} /> 
                                </div> 
                                <div className="col-lg-6">
                                    <label htmlFor="address" className="form-label">Address</label>
                                    <input type="text" className="form-control" name="address" id="address" {...register(`address`)}/>
                                </div> 
                            </div>
                            <div className="row g-3 mb-3"> 
                                <div className="col-lg-6">
                                    <label htmlFor="dob" className="form-label">Date of Birth</label>
                                    <input type="date" className="form-control" name="dob" id="dob" {...register(`dob`)}/>
                                </div>
                                <div className="col-lg-6">
                                    <label htmlFor="joiningDate" className="form-label">Date of Join</label>
                                    <input type="date" className="form-control" name="joiningDate" id="joiningDate" {...register(`joiningDate`)}/>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">  
                                <div className="col-lg-6"> 
                                    <label htmlFor="departmentId" className="form-label">Department</label> 
                                    <select className="form-select"
                                    name="departmentId"
                                    {...register(`departmentId`, {
                                        required: `Department is required!`,
                                    })}
                                    >
                                        <option value="">Select Department</option>
                                        {
                                            departmentDropdownData?.data?.map((category, idx)=>(
                                            <option value={category?.value}>{category?.label}</option>
                                            ))
                                        } 
                                    </select>  
                                    <Error errorName={errors?.parentId} />
                                </div>
                                <div className="col-lg-6"> 
                                    <label className="form-label">Status</label> 
                                    <br/>  
                                    <label className="fancy-radio parsley-error"> 
                                        <input type="radio" name="status" value="Active" checked={(status === "Active") ? "checked": ""} onChange={(e) => { setStatus(e.target.value); }} required data-parsley-errors-container="#error-radio" data-parsley-multiple="status" data-parsley-id="43" />
                                        <span className="px-2"><i></i>Active</span>
                                    </label>
                                    <label className="fancy-radio"> 
                                        <input type="radio" name="status" value="InActive" checked={(status === "InActive") ? "checked": ""} onChange={(e) => { setStatus(e.target.value); }} data-parsley-multiple="status" />
                                        <span className="px-2"><i></i>InActive</span>
                                    </label>  
                                </div>
                            </div>  
                            <div className="table-responsive">
                            <table className="table table-striped custom-table">
                                <thead>
                                    <tr> 
                                        <th>Modules</th>
                                        <th className="text-center">All</th> 
                                        <th className="text-center">Add</th> 
                                        <th className="text-center">Edit</th>
                                        <th className="text-center">List</th>
                                        <th className="text-center">Delete</th>
                                        <th className="text-center">View</th> 
                                    </tr>
                                </thead>
                                <tbody>    
                                    { 
                                        (Array.isArray(privilegesave) && privilegesave.length > 0) && 
                                        privilegesave.map((mods, keys)=> (  
                                            <tr key={keys}>   
                                                {
                                                    mods?.parentId === "0" ? (
                                                        <>
                                                        <td className="fw-bold">{mods?.name?.en}</td>
                                                            <td className=" text-center" colSpan={6}> 
                                                                <input className="w-4 h-4 text-blue-400 bg-blue-400 form-checkbox "
                                                                value={mods?.permissions?.list}
                                                                type="checkbox" name={mods.name.en+'_'+mods?.parentId} id={mods.id} 
                                                                onClick={handleAllClick}
                                                                checked={mods?.permissions?.list == 1 ? true : false}
                                                                /> 
                                                            </td> 
                                                        </> 
                                                    ) : (
                                                        <>
                                                            <td>{mods?.name?.en}</td>
                                                            <td className="text-center"> 
                                                                <input className="form-check-input" style={formInputStyle} type="checkbox" 
                                                                value={mods?.permissions?.add}
                                                                checked={mods?.permissions?.list === 1 && mods?.permissions?.view === 1 && mods?.permissions?.add === 1 && mods?.permissions?.edit === 1 && mods?.permissions?.delete === 1 ? true : false}
                                                                onClick={handleAllClick} name={mods.name.en+'_'+mods?.parentId} id={mods.id} />
                                                            </td>  
                                                            <td className="text-center"> 
                                                                <input className="form-check-input" style={formInputStyle} type="checkbox" id="add" value={mods?.permissions?.add} onClick={handleClick}  
                                                                checked={mods?.permissions?.add === 1 ? true : false} name={mods.name.en+'_add_'+mods?.parentId}/>
                                                            </td>  
                                                            <td className="text-center"> 
                                                                <input className="form-check-input" style={formInputStyle} type="checkbox" id="edit" value={mods?.permissions?.edit} onClick={handleClick}  
                                                                checked={mods?.permissions?.edit === 1 ? true : false} name={mods.name.en+'_edit_'+mods?.parentId}/>
                                                            </td> 
                                                            <td className="text-center">
                                                                <input className="form-check-input" style={formInputStyle} type="checkbox" id="list" value={mods?.permissions?.list} onClick={handleClick} 
                                                                checked={mods?.permissions?.list === 1 ? true : false} name={mods.name.en+'_list_'+mods?.parentId}/>
                                                            </td>
                                                            <td className="text-center">
                                                                <input className="form-check-input" style={formInputStyle} type="checkbox" id="delete" value={mods?.permissions?.delete} onClick={handleClick} 
                                                                checked={mods?.permissions?.delete === 1 ? true : false} name={mods.name.en+'_delete_'+mods?.parentId}/>
                                                            </td>
                                                            <td className="text-center"> 
                                                                <input className="form-check-input" style={formInputStyle} type="checkbox" id="view" value={mods?.permissions?.view} onClick={handleClick} 
                                                                checked={mods?.permissions?.view === 1 ? true : false} name={mods.name.en+'_view_'+mods?.parentId}/>
                                                            </td>  
                                                        </>   
                                                    )
                                                }
                                            </tr> 
                                        ))
                                    }
                                      
                                </tbody>
                            </table>
                        </div>
                    </div>  
                    

                </Modal.Body> 
                <Modal.Footer>                    
                    <button type="submit" className="btn btn-primary">{userId ? "Update " : "Add"}</button>
                    <button type="button" className="btn btn-secondary" onClick={() => { setIsModal(false) }}>Cancel</button>
                </Modal.Footer>
                </form> 
            </Modal>

            <Modal centered show={isViewModal} size="lg" onHide={() => { setIsViewModal(false); }}>
                <form onSubmit={handleSubmit(onSubmit)}> 
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">View User</Modal.Title>
                </Modal.Header>
                <Modal.Body> 

                <div className="deadline-form">

                    <div className="row g-3 mb-3"> 
                        <div className="col-lg-6"> 
                            <b> Name </b>
                        </div>
                        <div className="col-lg-6">
                            {viewData?.name}
                        </div>
                        <div className="col-lg-6"> 
                            <b> User Name </b>
                        </div>
                        <div className="col-lg-6">
                            {viewData?.username}
                        </div> 
                        <div className="col-lg-6"> 
                            <b> Email </b>
                        </div>
                        <div className="col-lg-6">
                            {viewData?.email}
                        </div> 
                        <div className="col-lg-6"> 
                            <b> Mobile No. </b>
                        </div>
                        <div className="col-lg-6">
                            {viewData?.phone}
                        </div> 
                        <div className="col-lg-6"> 
                            <b> Address </b>
                        </div>
                        <div className="col-lg-6">
                            {viewData?.address}
                        </div> 
                        <div className="col-lg-6"> 
                            <b> Date of Birth </b>
                        </div>
                        <div className="col-lg-6">
                            {viewData?.dob} 
                        </div> 
                        <div className="col-lg-6"> 
                            <b> Date of Join </b>
                        </div>
                        <div className="col-lg-6">
                            {viewData?.joiningDate}
                        </div> 
                        <div className="col-lg-6"> 
                            <b> Department </b>
                        </div>
                        <div className="col-lg-6">
                            {viewData?.departmentId?.departmentName}
                        </div> 
                        <div className="col-lg-6"> 
                            <b> Status </b>
                        </div>
                        <div className="col-lg-6">
                            {viewData?.status}
                        </div> 
                    </div>   
                    
                </div>   
                </Modal.Body>
                <Modal.Footer>                    
                    <button type="button" className="btn btn-secondary" onClick={() => { setIsViewModal(false) }}>Cancel</button>
                </Modal.Footer>
                </form> 
            </Modal> 

            {/* User delete modal */} 
            <Modal show={isDeleteModal} centered onHide={() => { setIsDeleteModal(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">Delete User</Modal.Title> 
                </Modal.Header>  
                <Modal.Body className="justify-content-center flex-column d-flex">
                    <i className="icofont-ui-delete text-danger display-2 text-center mt-2"></i> 
                    <p className="mt-4 fs-5 text-center">Are You Sure! Want to Delete User?</p>  
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={() => { setIsDeleteModal(false) }}>Cancel</button>
                    <button type="button" className="btn btn-danger color-fff" onClick={() => deleteUser(userId)}>Delete</button>
                </Modal.Footer>
            </Modal>
        </div> 
    )

}

export default UsersView;